import React, { useContext, useEffect, useState } from 'react';
import AppContext from '../../../Context/AppContext';
import { useImageWithFallback } from '../ELearningWorkspace/Dv2ElearningMedia';
import {
    PROGRAM_IDS,
    PROGRAM_CONFIG,
    calcProgress,
    programHeroPair,
} from '../ELearningWorkspace/programConfig';
import {
    getCachedModules,
    loadElearningModules,
} from '../elearningCache';
import '../ELearningWorkspace/elearningImageV2.css';
import './ELearningStrip.css';

const STRIP_CARDS = [
    { programId: PROGRAM_IDS.BREAKTHROUGH },
    { programId: PROGRAM_IDS.PATH },
    {
        programId: PROGRAM_IDS.ADDITIONAL,
        cta: 'Explore Programs',
    },
];

function progressFromModules(modules) {
    if (!modules) return {};
    return {
        [PROGRAM_IDS.BREAKTHROUGH]: calcProgress(
            modules.myBreakthroughExperience || []
        ),
        [PROGRAM_IDS.PATH]: calcProgress(modules.myPersonalizedPath || []),
    };
}

function StripProgramCard({ programId, progress, showBar, cta, onOpenProgram }) {
    const cfg = PROGRAM_CONFIG[programId];
    const hero = programHeroPair(programId);
    const bg = useImageWithFallback(hero.src, hero.fallbackSrc);

    return (
        <button
            type="button"
            className={`dv2-learn__card dv2-elimg-v2 dv2-learn__card--${programId}`}
            onClick={() => onOpenProgram && onOpenProgram(programId)}
        >
            <span
                className="dv2-learn__media"
                style={bg ? { backgroundImage: `url("${bg}")` } : undefined}
                aria-hidden="true"
            />
            <span className="dv2-learn__overlay">
                <h3>{cfg.stripTitle}</h3>
                {showBar ? (
                    <div className="dv2-learn__progress">
                        <div className="dv2-learn__bar">
                            <span style={{ width: `${progress || 0}%` }} />
                        </div>
                        <span className="dv2-learn__pct">{progress || 0}%</span>
                    </div>
                ) : (
                    <span className="dv2-learn__cta">{cta}</span>
                )}
            </span>
        </button>
    );
}

const ELearningStrip = ({ onOpenProgram }) => {
    const { checkUserSession } = useContext(AppContext);
    const { token, userId } = checkUserSession() || {};
    const cached = userId ? getCachedModules(userId) : null;
    const [progressMap, setProgressMap] = useState(() =>
        progressFromModules(cached)
    );

    useEffect(() => {
        if (!token || !userId) return undefined;
        let cancelled = false;

        async function loadProgress() {
            const hit = getCachedModules(userId);
            if (hit) setProgressMap(progressFromModules(hit));

            const { error, data } = await loadElearningModules(userId, token);
            if (cancelled || error || !data) return;
            setProgressMap(progressFromModules(data));
        }

        loadProgress();
        return () => {
            cancelled = true;
        };
    }, [token, userId]);

    return (
        <section className="dv2-learn dv2-glass">
            <div className="dv2-card-head">
                <div>
                    <h2 className="dv2-section-title">E-Learning</h2>
                    <p className="dv2-section-meta" style={{ margin: '6px 0 0' }}>
                        Continue Your Journey
                    </p>
                </div>
                <button
                    type="button"
                    className="dv2-card-cta"
                    onClick={() =>
                        onOpenProgram && onOpenProgram(PROGRAM_IDS.ADDITIONAL)
                    }
                >
                    View All Programs →
                </button>
            </div>
            <div className="dv2-learn__grid">
                {STRIP_CARDS.map((card) => (
                    <StripProgramCard
                        key={card.programId}
                        programId={card.programId}
                        progress={progressMap[card.programId]}
                        showBar={card.programId !== PROGRAM_IDS.ADDITIONAL}
                        cta={card.cta}
                        onOpenProgram={onOpenProgram}
                    />
                ))}
            </div>
        </section>
    );
};

export default ELearningStrip;
